/* Cart-only guard; no claim of native checkout/server enforcement. */
(function(root){
'use strict';
function requiresAgreement(submitter){return !submitter || submitter.name !== 'update';}
function permits(checked,submitter){return !requiresAgreement(submitter) || checked===true;}
if(typeof module!=='undefined')module.exports={requiresAgreement,permits};
if(!root.document)return;
const form=root.document.querySelector('[data-purchase-terms-form]');
if(!form)return;
const box=form.querySelector('#purchase-terms');
const error=form.querySelector('#purchase-terms-error');
form.addEventListener('submit',event=>{
 if(!permits(box?.checked,event.submitter)){
  event.preventDefault();if(error)error.hidden=false;box?.focus();
 }
});
box?.addEventListener('change',()=>{if(error)error.hidden=true;});
})(typeof window==='undefined'?globalThis:window);
